import { PointElement, } from 'chart.js';
import { renderErrorBar, errorBarDefaults, errorBarDescriptors } from './render';
class PointWithErrorBar extends PointElement {
    draw(ctx, area) {
        super.draw.call(this, ctx, area);
        renderErrorBar(this, ctx);
    }
}
PointWithErrorBar.id = 'pointWithErrorBar';
PointWithErrorBar.defaults = { ...PointElement.defaults, ...errorBarDefaults };
PointWithErrorBar.defaultRoutes = PointElement.defaultRoutes;
PointWithErrorBar.descriptors = errorBarDescriptors;
export default PointWithErrorBar;
//# sourceMappingURL=PointWithErrorBar.js.map